var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentsNewSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_781_9816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 18.0428V20.7286",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3572 16.7V19.3857",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.64294 16.7V19.3857",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.29287 8.97856C6.10746 8.97856 5.95715 8.82825 5.95715 8.64284C5.95715 8.45743 6.10746 8.30713 6.29287 8.30713",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.29285 8.97856C6.47825 8.97856 6.62856 8.82825 6.62856 8.64284C6.62856 8.45743 6.47825 8.30713 6.29285 8.30713",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7072 8.97856C17.5217 8.97856 17.3715 8.82825 17.3715 8.64284C17.3715 8.45743 17.5217 8.30713 17.7072 8.30713",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7072 8.97856C17.8926 8.97856 18.0429 8.82825 18.0429 8.64284C18.0429 8.45743 17.8926 8.30713 17.7072 8.30713",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4285 7.1507C13.3794 7.0117 13.3036 6.88531 13.2073 6.77768C13.0023 6.54874 12.7046 6.40466 12.3731 6.40466H11.507C10.9553 6.40466 10.5081 6.85189 10.5081 7.40357C10.5081 7.873 10.8349 8.27909 11.2935 8.3794L12.6123 8.66789C13.126 8.78026 13.4922 9.23553 13.4922 9.76142C13.4922 10.3795 12.9912 10.8809 12.3731 10.8809H11.6271C11.1399 10.8809 10.7253 10.5695 10.5717 10.1348",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6.40476V5.28571",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12.0001V10.881",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3858 3.27142H4.61434C3.8727 3.27142 3.27148 3.87264 3.27148 4.61428V12.6714C3.27148 13.4131 3.8727 14.0143 4.61434 14.0143H19.3858C20.1274 14.0143 20.7286 13.4131 20.7286 12.6714V4.61428C20.7286 3.87264 20.1274 3.27142 19.3858 3.27142Z",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_781_9816"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentsNewSelected);
export default __webpack_public_path__ + "static/media/PaymentsNewSelected.cdbc6c1a45ad22df2e68b3e760884628.svg";
export { ForwardRef as ReactComponent };